import styled from "styled-components";

export const ContainerPagination = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 10px;
`

export const ContainerSelectBusiness = styled.div`
    min-width: 350px;
`